import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function attendAlone(affectedStaffId: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.attendAlone.url, { id: affectedStaffId }))
    .post()
}
